export default "__VITE_ASSET__dpem3dLh__"